import React, { Component } from 'react';
import { Form, Input, Label, Radio, Button, Dropdown } from '../../../Form';

import withTranslations from '../../../../utils/translations/withTranslations';

class Pilot extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: true
    };
  }

  next() {
    this.props.saveItem(this.form.formData());
    this.props.next();
  }

  render() {
    const { translate, data = {} } = this.props;
    const { isValid } = this.state;

    return (
      <div className="Pilot">
        <h1>{translate('fiche.pilot.title')}</h1>
        <Form
          ref={form => (this.form = form)}
          onValidationChange={valid => this.setState({ isValid: valid })}
          className="Pilot__Form"
        >
          <Label text={translate('fiche.pilot.salutation')} />
          <Radio
            name="salutation"
            rules={['required']}
            data={[
              {
                value: 'M',
                label: translate('fiche.pilot.sir'),
                checked: data.salutation === 'M'
              },
              {
                value: 'F',
                label: translate('fiche.pilot.madam'),
                checked: data.salutation === 'F'
              }
            ]}
          />

          <Label text={translate('fiche.pilot.first_name')} />
          <Input
            name="first_name"
            rules={['required']}
            defaultValue={data.first_name}
          />

          <Label text={translate('fiche.pilot.last_name')} />
          <Input
            name="last_name"
            rules={['required']}
            defaultValue={data.last_name}
          />

          <Label text={translate('fiche.pilot.birthday')} />
          <Input
            name="birthday"
            rules={['required', 'birthday']}
            placeholder="DD/MM/YYYY"
            defaultValue={data.birthday}
          />

          <Label text={translate('fiche.pilot.state_registration_number')} />
          <Input
            name="state_registration_number"
            rules={['required']}
            defaultValue={data.state_registration_number}
          />

          <Label text={translate('fiche.pilot.email')} />
          <Input name="email" rules={['email']} defaultValue={data.email} />

          <Label text={translate('fiche.pilot.federation')} />
          <Dropdown
            name="federation"
            data={translate('fiche.pilot.federations')}
            rules={['required']}
            placeholder={translate('fiche.pilot.federation_placeholder')}
            defaultValue={data.federation}
          />

          <h2>{translate('fiche.pilot.address.title')}</h2>
          <Label text={translate('fiche.pilot.address.country')} />
          <Dropdown
            name="country"
            data={translate('fiche.pilot.address.countries')}
            rules={['required']}
            defaultValue={data.country}
          />

          <div className="Form__Horizontal">
            <div className="Form__Horizontal__Item">
              <Label text={translate('fiche.pilot.address.street')} />
              <Input
                name="street"
                rules={['required']}
                defaultValue={data.street}
              />
            </div>
            <div className="Form__Horizontal__Item Form__Horizontal__Item--30">
              <Label text={translate('fiche.pilot.address.house_number')} />
              <Input
                name="house_number"
                rules={['required']}
                defaultValue={data.house_number}
              />
            </div>
          </div>

          <div className="Form__Horizontal">
            <div className="Form__Horizontal__Item">
              <Label text={translate('fiche.pilot.address.postal_code')} />
              <Input
                name="postal_code"
                rules={['required']}
                defaultValue={data.postal_code}
              />
            </div>
            <div className="Form__Horizontal__Item">
              <Label text={translate('fiche.pilot.address.city')} />
              <Input
                name="city"
                rules={['required']}
                defaultValue={data.city}
              />
            </div>
          </div>

          <Button
            solid
            className="Form__Button"
            disabled={!isValid}
            onClick={() => this.next()}
          >
            {translate('fiche.next')}
          </Button>
        </Form>
      </div>
    );
  }
}

export default withTranslations(Pilot);
